import { IPunchhOptions } from '@ready/dashboardv2api.contracts/dist/src/contracts/api/companyLoyaltyConfig/punchh/IPunchhOptions';
import { RootState } from 'redux/store';

export const selectCompanyPunchOptions = (state: RootState): IPunchhOptions | undefined =>
  state.companies.companySettings.loyalty.loyaltyConfigs.punchh;
